// NAVBAR COMPONENT, SHOWN AT THE TOP OF EVERY SUBPAGE

import React, { useState, useContext } from "react";
import { LanguageContext } from "./../language-context";
import * as variables from "./helper/Variables";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Button } from "./helper/Button";

const Nav = styled.nav`
  position: fixed;
  ${variables.FlexJustifyBetween};
  width: 100vw;
  height: 6rem;
  padding: 0 1.5rem 0 2rem;
  z-index: 3;
`;

const NoUnderlineLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`;

const AuthorWrapper = styled.div`
  ${variables.FlexAlignStart};
  flex-direction: column;
  width: auto;
  color: ${variables.DARK};
`;

const AuthorName = styled.p`
  font-size: 1.5rem;
  font-weight: 800;
`;

const AuthorPseudonym = styled.p`
  font-family: "Open Sans Condensed", sans-serif;
`;

const MenuButtonWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 25vw;
  z-index: 4;
`;

export const Navbar = () => {
  const usedLanguage = useContext(LanguageContext);

  const { menuButton, closeMenuButton } = usedLanguage.language.menu;

  const [menuButtonName, setMenuButtonName] = useState(menuButton);
  const [color, setColor] = useState(variables.DARK);
  const [noHover, setNoHover] = useState(true);
  const [width, setWidth] = useState("0vw");

  const changeMenuButton = () => {
    menuButtonName === menuButton
      ? setMenuButtonName(closeMenuButton)
      : setMenuButtonName(menuButton);
    color === `${variables.DARK}`
      ? setColor(`${variables.DIMGRAY}`)
      : setColor(`${variables.DARK}`);
    noHover === true ? setNoHover(false) : setNoHover(true);
    width === "0vw" ? setWidth("100vw") : setWidth("0vw"); //Used to show Sidebar by changing its width
  };

  return (
    <>
      <Nav>
        <NoUnderlineLink to={"/"}>
          <AuthorWrapper>
            <AuthorName>MICHAŁ KRÓL</AuthorName>
            <AuthorPseudonym>Structuralist</AuthorPseudonym>
          </AuthorWrapper>
        </NoUnderlineLink>
        <MenuButtonWrapper>
          <Button
            text={menuButtonName}
            clickHandler={changeMenuButton}
            color={color} //Styled Components props
            noHover={noHover} //Styled Components props
            fontSize={"1.2rem"}
          />
        </MenuButtonWrapper>
      </Nav>
      <Sidebar
        changeMenuButton={changeMenuButton}
        width={width} //Styled Components props
      />
    </>
  );
};
